<div id="overlay" role="dialog" aria-modal="true" aria-labelledby="overlay-title" aria-describedby="overlay-description">
    <div class="saving-message-div" role="status" aria-live="assertive" aria-atomic="true" aria-busy="true">

        <h2 id="overlay-title" *ngIf="content !== undefined">{{content}}</h2>
        <h2 id="overlay-title" *ngIf="content === undefined">Saving</h2>
        <p id="overlay-description" class="sr-only">Please wait while your request is being processed.</p>
        <div class="loading" aria-hidden="true">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </div> 
    </div>
</div>